import useUserAttributes from "@/features/user/hooks/useUserAttributes";
import { IndustryEntity, OccupationEntity } from "@/web-client";
import { useMemo } from "react";

type CheckJobForProAccount = {
  selectedOccupation: OccupationEntity | undefined;
  selectedIndustry: IndustryEntity | undefined;
  recommendDesigner: boolean;
};

export const useCheckJobForProAccount = (
  industry_id?: number,
  occupation_id?: number,
): CheckJobForProAccount => {
  const { industries, occupations } = useUserAttributes();

  const selectedOccupation = useMemo<OccupationEntity | undefined>(() => {
    if (!occupation_id) return undefined;

    return occupations.find((occupation) => occupation.id == occupation_id);
  }, [occupations, occupation_id]);

  const selectedIndustry = useMemo<IndustryEntity | undefined>(() => {
    if (!industry_id) return undefined;

    return industries.find((industry) => industry.id == industry_id);
  }, [industries, industry_id]);

  const recommendDesigner = useMemo<boolean>(() => {
    if (selectedOccupation == undefined || selectedIndustry == undefined)
      return false;

    // 業種もしくは職種のどちらかがデザイナーの場合はPROアカウントを推奨
    return selectedOccupation.is_designer || selectedIndustry.is_designer;
  }, [selectedOccupation, selectedIndustry]);

  return {
    selectedIndustry,
    selectedOccupation,
    recommendDesigner,
  };
};
